import { useEventListener } from '@beef/react';
import { extractId, findAncestorWithTagName } from "./utils";
import { headerAwareSmoothScroll } from "../utils/headerAwareSmoothScroll";
export var useTabLinkListener = function useTabLinkListener(id, onClick) {
  useEventListener('click', function (event) {
    if (!id || !onClick) return;
    var anchor = findAncestorWithTagName(event.target, 'A');
    if (!anchor) return;
    var href = anchor.getAttribute('href');
    var targetId = extractId(href, /^#openTabItem:(.*)$/i);
    if (!targetId) return;
    event.preventDefault();
    if ((id === null || id === void 0 ? void 0 : id.toLowerCase()) === (targetId === null || targetId === void 0 ? void 0 : targetId.toLowerCase())) {
      var _document$getElementB;
      headerAwareSmoothScroll(id);
      // для отображение контента таба
      (_document$getElementB = document.getElementById(id)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      onClick();
    }
  }, typeof document !== 'undefined' && id ? document.body : undefined);
};